<template>
  <div class="mt-2">
    <RequisitionList
      mode="open"
      meta-name="Open"
    />
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import RequisitionList from '@/components/requisitions/RequisitionList.vue';
import { useAppBase } from '@/stores/app/base';

export default {
  name: 'OpenReqList',
  components: {
    RequisitionList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Requisitions: Open' });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
  },
};
</script>
